import RegisterInfoDescription from './RegisterInfoDescription';

export default RegisterInfoDescription;
